import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export const state = {
  templateList: [],
  enum: '',
  condition: {
    page: 1,
    limit: 100
  },
  dynamicLink: '',
  audio: null,
  audioPlayer: null,
  muted: true,
  bibleList: [],
  businessList: [],
  targetNo: null,
  // 260513 feature flag — 진입 시 1회 fetch 후 캐시
  featureFlags: {},
  featureFlagsLoaded: false
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
